import { render, staticRenderFns } from "./outstanding-ac-reviewer.vue?vue&type=template&id=b4a04ece&scoped=true"
import script from "./outstanding-ac-reviewer.vue?vue&type=script&lang=js"
export * from "./outstanding-ac-reviewer.vue?vue&type=script&lang=js"
import style0 from "./outstanding-ac-reviewer.vue?vue&type=style&index=0&id=b4a04ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a04ece",
  null
  
)

export default component.exports